<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Thời Khóa Biểu" :link="[{ text: 'Thời khóa biểu', href: '../ownClassTimeTable' }]" />
      </div>
    </div>
    <v-card class="mx-4 pt-2 full-height elevation-0" outlined>
      <ClassTimeTable />
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ClassTimeTable from '@/modules/timeTable/ClassTimeTable.vue'

export default {
  components: {
    Breadcrumbs,
    ClassTimeTable
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
